<template lang="pug">
div
  div(class="flex flex-wrap sm:flex-no-wrap items-center mb-16 md:mb-24")
    div(
      v-for="(accommodationType, index) in accommodationTypes"
      :class="{'ml-10': index > 0, active: selectedType.value === accommodationType.value}"
      class="estimate-card flex flex-col items-center justify-center cursor-pointer rounded shadow hover:shadow-lg h-110p w-110p bg-white hover:bg-primary group transition-smooth"
      @click="() => { selectedType = accommodationType }"
    )
      i.fal.fa-2x(:class="`fa-${accommodationType.icon}`" class="text-primary group-hover:text-white transition-smooth mb-4")
      p(class="text-primary group-hover:text-white transition-smooth font-light") {{ accommodationType.label }}

  div
    slot(:selectedType="selectedType" :isInside="isInside" :isOutside="isOutside" :isBuilding="isBuilding")
</template>

<script>
export default {
  props: {
    currentType: {
      type: String,
      default: ''
    },

    accommodationTypes: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      selectedType: {}
    }
  },

  computed: {
    isInside () {
      return ['house', 'apartment'].includes(this.selectedType.value)
    },

    isOutside () {
      return ['house', 'land'].includes(this.selectedType.value)
    },

    isBuilding () {
      return ['building'].includes(this.selectedType.value)
    }
  },

  watch: {
    currentType: {
      immediate: true,
      handler () {
        this.selectedType = this.accommodationTypes.find(c => c.value === this.currentType) || {}
      }
    }
  }
}
</script>
